var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHierarchicalStructure = function SvgHierarchicalStructure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.667 30.333h150.667V181H180.667zM0 331h150.667v150.667H0zM180.667 331h150.667v150.667H180.667zM90.333 271H241v30h30v-30h150.667v30h30v-60H271v-30h-30v30H60.333v60h30zM361.333 331H512v150.667H361.333z"
  })));
};
export default SvgHierarchicalStructure;